import React from "react";
import { Grid, TextField } from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import GooglePlacesInputComponent from "../../ui/GooglePlacesInputComponent";
import SelectInputComponent from "../../ui/SelectInputComponent";
import TextInputComponent from "../../ui/TextInputComponent";

const LogisticsStep = ({ formData = {}, setFormData, errors, handleChange, handlePlaceSelect }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
      <GooglePlacesInputComponent
        key={formData.eventId || "new"}
        label="Location"
        value={formData.locationDetails}
        onChange={(location) => {
            setFormData((prev) => ({
            ...prev,
            location: location.address,
            locationLat: location.lat,
            locationLng: location.lng,
            locationPlaceId: location.placeId,
            locationDetails: location,
            }));

            // Also trigger parent-level handler
            if (handlePlaceSelect) {
            handlePlaceSelect(location);
            }
        }}
        error={errors.location}
        />
      </Grid>

      <Grid item xs={6} md={3}>
        <DatePicker
          label="Start Date"
          value={formData.startDate}
          onChange={(value) => setFormData({ ...formData, startDate: value })}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={!!errors.startDate}
              helperText={errors.startDate}
            />
          )}
        />
      </Grid>

      <Grid item xs={6} md={3}>
        <TimePicker
          label="Start Time"
          value={formData.startTime}
          onChange={(value) => setFormData({ ...formData, startTime: value })}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={!!errors.startTime}
              helperText={errors.startTime}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextInputComponent
          label="Budget"
          value={formData.budget}
          onChange={(e) =>
            setFormData({ ...formData, budget: e.target.value })
          }
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <SelectInputComponent
          label="Target Audience"
          value={formData.targetAudience}
          onChange={handleChange("targetAudience")}
          options={[
            { label: "Donors", value: "Donors" },
            { label: "Families/Clients", value: "Families/Clients" },
            { label: "Volunteers", value: "Volunteers" },
            { label: "All", value: "All" },
          ]}
          multiple
          required
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <DatePicker
          label="Registration Deadline"
          value={formData.registrationDeadline}
          onChange={(value) =>
            setFormData({ ...formData, registrationDeadline: value })
          }
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextInputComponent
          label="Max Attendees"
          value={formData.maxAttendees}
          onChange={(e) =>
            setFormData({ ...formData, maxAttendees: e.target.value })
          }
        />
      </Grid>
    </Grid>
  );
};

export default LogisticsStep;